export class Button {
  name: string;
  color: string;
  action: string;
  icon: string;
}
